<div class="overlay-inner-wrapper">
  <header class="header-2">
    <div class="branding">
      <span class="title">{{ 'Rückmeldung' | mrTranslate }} - {{bezeichnung}}</span>
    </div>
    <div class="header-actions">
      <clr-dropdown>
        <button class="nav-icon" clrDropdownTrigger aria-label="toggle settings menu">
          <cds-icon shape="cog" />
        </button>
        <clr-dropdown-menu *clrIfOpen clrPosition="bottom-right">
          <a (click)="createMangel()" clrDropdownItem>
            <cds-icon style="color: currentColor" size="22" shape="plus-circle" />
            {{ 'Mangel anlegen' | mrTranslate | titlecase }}
          </a>

          @if (candoteilinst) {
            <a (click)="showTeilinstandsetzung($event)" clrDropdownItem>
              <cds-icon style="color: currentColor" size="22" shape="share" />
              {{ 'Teilinstandsetzung' | mrTranslate | titlecase }}
            </a>
          }

          @if (typ_Line_Point == 2 || typ_Line_Point == 4) {
            <div class="dropdown-divider" role="separator"></div>
            <a (click)="showErneuerung($event)" clrDropdownItem>
              <cds-icon style="color: currentColor" size="22" shape="repeat" />
              {{ 'Erneuerung' | mrTranslate | titlecase }}
            </a>
          }

          <!-- <div *ngIf="UseKomponenten === true" class="dropdown-divider" role="separator"></div>
          <a *ngIf="UseKomponenten === true" (click)="addKomponenten()" clrDropdownItem>{{'Neue Komponente erstellen' | mrTranslate}}</a>
          <a *ngIf="selnodeid !== 0" (click)="editKomponenten()" clrDropdownItem>{{'Komponente bearbeiten' | mrTranslate}}</a>
          <a *ngIf="selnodeid !== 0" (click)="delKomponenten()" clrDropdownItem>{{'Komponente löschen' | mrTranslate}}</a> -->
        </clr-dropdown-menu>
      </clr-dropdown>
      <a href="javascript:void(0);" class="nav-link nav-icon" (click)="close()">
        <cds-icon shape="times" />
      </a>
    </div>
  </header>

  @if (this.openTab != 'paint') {
    <form clrForm [formGroup]="formGroup" [clrLabelSize]="4" class="width100">
      <div class="clr-row nxm" #heightRef>
        <div class="clr-col-sm" style="margin-left: 10px">
          <clr-date-container>
            <!--  style="margin-top: 0.6em" -->
            <label>{{ 'Datum' | mrTranslate }}</label>
            <input
              type="date"
              clrDate
              name="datum"
              [ngModel]="formGroup.get('instandsetzungsdatum').value | localeDate"
              (ngModelChange)="formGroup.get('instandsetzungsdatum').setValue(localeDate.tosql($event))"
              [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
              [disabled]="formGroup.disabled"
              required />
          </clr-date-container>
          <clr-select-container>
            <label>{{ 'Firma' | mrTranslate }}</label>
            <select clrSelect formControlName="firma">
              @for (c of firmen; track c) {
                <option [ngValue]="+c.ID">{{ c.mFirma }}</option>
              }
            </select>
          </clr-select-container>
          @if (this.openTab == 'mangel') {
            <clr-textarea-container>
              <label>{{ 'Rückmeldetext' | mrTranslate }}</label>
              <textarea rows="2" clrTextarea formControlName="rueckmeldetext" name="description"></textarea>
            </clr-textarea-container>
          }
        </div>
        <div class="clr-col-sm-1"></div>
        <div class="clr-col-sm">
          @if (selectedmangel.length == 1 && this.openTab == 'mangel') {
            <clr-textarea-container>
              <label>{{ 'Teilerneuerung' | mrTranslate }}</label>
              <textarea rows="2" clrTextarea formControlName="teilerneuerung" name="description"></textarea>
            </clr-textarea-container>
          }
          @if (this.openTab == 'mangel' && selectedmangel.length == 1) {
            <clr-textarea-container>
              <label>{{ 'Bemerkung' | mrTranslate }}</label>
              <textarea rows="2" clrTextarea formControlName="bemerkung" name="description"></textarea>
            </clr-textarea-container>
          }
        </div>
      </div>
    </form>
  }

  <div class="clr-row nxm" style="padding-left: 10px; padding-right: 10px">
    <clr-tabs class="w-100-p">
      @if (mangel?.rows.length || mangelErl?.rows.length) {
        <clr-tab>
          <button clrTabLink (click)="tabChange('mangel')" id="link1">
            {{ 'Mängel' | mrTranslate }}
          </button>
          <clr-tab-content id="content1" *clrIfActive="openTab == 'mangel'">
            <form id="rueckmeldungsMangelForm">
              <div class="clr-row nxm">
                <div class="clr-col-12">
                  <clr-datagrid
                    class="datagrid-compact"
                    style="height: 260px"
                    [clrDgSelectionType]="'multi'"
                    [(clrDgSelected)]="selectedmangel"
                    [clrDgRowSelection]="true"
                    (clrDgSelectedChange)="selectedmangelChanged($event)"
                    [clrDgItemsIdentityFn]="row => row?.OMAZSID">
                    @for (column of mangel?.columns; track $index) {
                      <clr-dg-column
                        [clrDgField]="column.id"
                        [title]="column.id"
                        [style.width]="columnWidthsMangel[column.id]">
                        <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
                          {{ column.id | titlecase }}
                        </ng-container>
                      </clr-dg-column>
                    }
                    <ng-template
                      clrVirtualScroll
                      let-row
                      let-index="index"
                      [clrVirtualRowsOf]="mangel?.rows"
                      [clrVirtualRowsTrackBy]="(_, row) => row?.OMAZSID">
                      <clr-dg-row [clrDgItem]="row">
                        @for (cell of mangel?.columns; track $index) {
                          <clr-dg-cell><app-icon-dg-cell [row]="row" [column]="cell" /></clr-dg-cell>
                        }
                      </clr-dg-row>
                    </ng-template>
                    <clr-dg-footer>{{ mangel?.rows?.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                  </clr-datagrid>
                </div>
                @if (mangel?.rows.length && selectedmangel.length == 1) {
                  <div class="clr-col-12 margin-10-t">
                    <app-preview-thumbnails [maxAmount]="6"></app-preview-thumbnails>
                  </div>
                }
                <div class="clr-col-12" style="padding-top: 10px">
                  <button
                    class="btn btn-primary"
                    [disabled]="trial || !selectedmangel.length"
                    (click)="onMangelSubmit()">
                    {{ selectedmangel.length + ' ' + (selectedmangel.length == 1 ? 'Mangel' : 'Mängel') | mrTranslate }}
                    {{ 'rückmelden' | mrTranslate }}
                  </button>
                </div>

                @if (mangelErl?.rows.length) {
                  <div class="clr-col-12">
                    <clr-datagrid
                      class="datagrid-compact"
                      style="height: 200px"
                      [clrDgSelectionType]="'single'"
                      [clrDgSelected]="[selectedInstMangel]"
                      (clrDgSelectedChange)="selectedInstMangel = $event[0]"
                      [clrDgRowSelection]="true"
                      [clrDgItemsIdentityFn]="row => row?.OMAZSID">
                      @for (column of mangelErl?.columns; track $index) {
                        <clr-dg-column
                          [clrDgField]="column.id"
                          [title]="column.id"
                          [style.width]="columnWidthsMangelErl[column.id]">
                          <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['lf', 'LF'] }">
                            {{ column.id | titlecase }}
                          </ng-container>
                        </clr-dg-column>
                      }
                      <ng-template
                        clrVirtualScroll
                        let-row
                        let-index="index"
                        [clrVirtualRowsOf]="mangelErl?.rows"
                        [clrVirtualRowsTrackBy]="(_, row) => row?.OMAZSID">
                        <clr-dg-row [clrDgItem]="row">
                          @for (cell of mangelErl?.columns; track $index) {
                            <clr-dg-cell><app-icon-dg-cell [row]="row" [column]="cell" /></clr-dg-cell>
                          }
                        </clr-dg-row>
                      </ng-template>
                      <clr-dg-footer>{{ mangelErl?.rows?.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                    </clr-datagrid>
                  </div>
                }
                @if (mangelErl?.rows.length) {
                  <div class="clr-col-12" style="padding-top: 10px">
                    <div class="btn-group btn-primary btn-icon">
                      <button
                        class="btn btn-icon btn btn-danger"
                        [title]="'Rückmeldung löschen' | mrTranslate"
                        [disabled]="trial || !selectedInstMangel"
                        (click)="onMangelDelRueckmeldung()">
                        <cds-icon shape="times" />
                      </button>
                    </div>
                  </div>
                }
              </div>
            </form>
          </clr-tab-content>
        </clr-tab>
      }
      @if (messungen?.rows.length || messungenErl?.rows.length) {
        <clr-tab>
          <button clrTabLink (click)="tabChange('messung')" id="link2">
            {{ 'Messungen' | mrTranslate }}
          </button>
          <clr-tab-content *clrIfActive="openTab == 'messung'">
            <form id="rueckmeldungsMessungForm" clrForm>
              <div class="clr-row nxm">
                <div class="clr-col-12">
                  <clr-datagrid
                    class="datagrid-compact"
                    [style.height]="messungenErl?.rows?.length > 0 ? 'calc(100vh - 470px)' : 'calc(100vh - 280px)'"
                    [clrDgItemsIdentityFn]="row => row?.ID"
                    [clrDgSelectionType]="'single'"
                    [clrDgSelected]="[selectedmess]"
                    (clrDgSelectedChange)="selectedmess = $event[0]; selectMessung($event[0])">
                    @for (column of messungen?.columns; track $index) {
                      <clr-dg-column [clrDgField]="column.id" [title]="column.id">
                        <ng-container
                          *clrDgHideableColumn="{
                            hidden:
                              column.id
                              | hideIDColumns
                                : [
                                    'iausfall',
                                    'instand',
                                    'status',
                                    'username',
                                    'bemerkung',
                                    'ex_infralife',
                                    'mposition',
                                    'ztyp',
                                    'info',
                                    'messender',
                                    'instandsetzer',
                                    'instand_datum',
                                    'instand_messender',
                                    'ist_neu',
                                  ],
                          }">
                          {{ column.id | titlecase }}
                        </ng-container>
                      </clr-dg-column>
                    }
                    <clr-dg-column>{{ 'Ist-Neu' | mrTranslate }}</clr-dg-column>
                    <clr-dg-column>{{ 'Ausfall-Neu' | mrTranslate }}</clr-dg-column>
                    <clr-dg-column>{{ 'Messdender-Neu' | mrTranslate }}</clr-dg-column>

                    <ng-template
                      clrVirtualScroll
                      let-row
                      let-index="index"
                      [clrVirtualRowsOf]="messungen?.rows"
                      [clrVirtualRowsTrackBy]="(_, row) => row?.ID">
                      <clr-dg-row [clrDgItem]="row">
                        @for (cell of messungen?.columns; track $index) {
                          <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                        }
                        <clr-dg-cell>{{ row.IstNeu }}</clr-dg-cell>
                        <clr-dg-cell>{{ row.IAusfall }}</clr-dg-cell>
                        <clr-dg-cell>{{ row.Instand_Messender }}</clr-dg-cell>
                      </clr-dg-row>
                    </ng-template>
                    <clr-dg-detail *clrIfDetail="let detail">
                      <clr-dg-detail-header>
                        {{ 'Messpunkt' | mrTranslate }} • {{ detail.Bezeichnung }}
                      </clr-dg-detail-header>
                      <clr-dg-detail-body>
                        <form clrForm>
                          <strong>{{ 'Sollwerte' | mrTranslate }}</strong>
                          <table class="table" style="width: 300px; text-align: left">
                            <thead>
                              <tr>
                                <th style="text-align: left; width: 150px">{{ 'Bezeichnung' | mrTranslate }}</th>
                                <th style="text-align: left; width: 150px">{{ 'Wert' | mrTranslate }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td style="text-align: left; width: 150px">{{ 'Soll' | mrTranslate | titlecase }}</td>
                                <td style="text-align: left; width: 150px">{{ detail.Soll }}</td>
                              </tr>
                              @if (toleranz[0]['USE_100'] == 1) {
                                <tr>
                                  <td style="text-align: left; width: 150px">{{ toleranz[0]['TEXT_0_p'] }}</td>
                                  <td style="text-align: left; width: 150px">
                                    {{ detail[toleranz[0]['TEXT_100_p']] }}
                                  </td>
                                </tr>
                                <tr>
                                  <td style="text-align: left; width: 150px">{{ toleranz[0]['TEXT_0_m'] }}</td>
                                  <td style="text-align: left; width: 150px">
                                    {{ detail[toleranz[0]['TEXT_100_m']] }}
                                  </td>
                                </tr>
                              }
                              @if (toleranz[0]['USE_L'] == 1) {
                                <tr>
                                  <td style="text-align: left; width: 150px">{{ toleranz[0]['TEXT_L_p'] }}</td>
                                  <td style="text-align: left; width: 150px">{{ detail[toleranz[0]['TEXT_L_p']] }}</td>
                                </tr>
                                <tr>
                                  <td style="text-align: left; width: 150px">{{ toleranz[0]['TEXT_L_m'] }}</td>
                                  <td style="text-align: left; width: 150px">{{ detail[toleranz[0]['TEXT_L_m']] }}</td>
                                </tr>
                              }
                              @if (toleranz[0]['USE_G'] == 1) {
                                <tr>
                                  <td style="text-align: left; width: 150px">{{ toleranz[0]['TEXT_G_p'] }}</td>
                                  <td style="text-align: left; width: 150px">{{ detail[toleranz[0]['TEXT_G_p']] }}</td>
                                </tr>
                                <tr>
                                  <td style="text-align: left; width: 150px">{{ toleranz[0]['TEXT_G_m'] }}</td>
                                  <td style="text-align: left; width: 150px">{{ detail[toleranz[0]['TEXT_G_m']] }}</td>
                                </tr>
                              }
                            </tbody>
                          </table>
                          <br />
                          <table style="width: 300px; text-align: left; margin-left: 5px">
                            <tr>
                              <td style="text-align: left; width: 150px; height: 32px">
                                <strong>{{ 'Ist-Wert' | mrTranslate | titlecase }}</strong>
                              </td>
                              <td style="text-align: left; width: 150px; height: 32px; padding-left: 10px">
                                <strong>{{ detail.Ist }}</strong>
                              </td>
                            </tr>
                          </table>
                          <br />
                          <strong>{{ 'Rückmeldung' | mrTranslate }}</strong>
                          <table style="width: 300px; text-align: left">
                            <tr>
                              <td style="text-align: left; width: 150px; height: 32px">
                                {{ 'Ist-Neu' | mrTranslate | titlecase }}
                              </td>
                              <td style="text-align: left; width: 150px; height: 32px">
                                <clr-input-container>
                                  <input
                                    clrInput
                                    name="istneu"
                                    [(ngModel)]="detail.IstNeu"
                                    style="width: 135px"
                                    (blur)="onBlurMethod(detail, $event.target.value)" />
                                </clr-input-container>
                              </td>
                            </tr>
                            <tr>
                              <td style="text-align: left; width: 150px; height: 32px">
                                {{ 'Ausfall' | mrTranslate | titlecase }}
                              </td>
                              <td style="text-align: left; width: 150px; height: 32px; padding-left: 35px">
                                {{ detail.IAusfall }}
                              </td>
                            </tr>
                            <tr>
                              <td style="text-align: left; width: 150px; height: 32px">
                                {{ 'Messender' | mrTranslate | titlecase }}
                              </td>
                              <td style="text-align: left; width: 150px; height: 32px">
                                <clr-input-container>
                                  <input
                                    clrInput
                                    name="messenderneu"
                                    [(ngModel)]="detail.Instand_Messender"
                                    style="width: 135px" />
                                </clr-input-container>
                              </td>
                            </tr>
                          </table>
                          <br />
                          <clr-textarea-container style="margin-left: 0px; max-width: 450px">
                            <label style="width: 150px">{{ 'Bemerkung' | mrTranslate | titlecase }}</label>
                            <textarea
                              clrTextarea
                              [(ngModel)]="detail.Bemerkung"
                              name="description"
                              style="padding: 5px"></textarea>
                          </clr-textarea-container>
                        </form>
                        <br />
                        <button
                          class="btn btn-primary"
                          [disabled]="trial || !detail?.IstNeu"
                          (click)="onMessungSubmit(detail)">
                          {{ 'Messung rückmelden' | mrTranslate }}
                        </button>
                      </clr-dg-detail-body>
                    </clr-dg-detail>
                    <clr-dg-footer>
                      <div class="footer-info">{{ infomessung }}</div>
                      {{ mangel?.rows?.length }} {{ 'Zeilen' | mrTranslate }}
                    </clr-dg-footer>
                  </clr-datagrid>
                </div>
                @if (messungenErl?.rows.length) {
                  <div class="clr-col-12">
                    <clr-datagrid
                      class="datagrid-compact"
                      style="height: 150px"
                      [clrDgSelectionType]="'single'"
                      [clrDgSelected]="[selectedInstMessung]"
                      (clrDgSelectedChange)="selectedInstMessung = $event[0]"
                      [clrDgRowSelection]="true"
                      [clrDgItemsIdentityFn]="row => row?.ID">
                      @for (column of messungenErl?.columns; track $index) {
                        <clr-dg-column
                          [clrDgField]="column.id"
                          [title]="column.id"
                          [style.width]="columnWidthsMessErl[column.id]">
                          <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
                            {{ column.id | titlecase }}
                          </ng-container>
                        </clr-dg-column>
                      }
                      <ng-template
                        clrVirtualScroll
                        let-row
                        let-index="index"
                        [clrVirtualRowsOf]="messungenErl?.rows"
                        [clrVirtualRowsTrackBy]="(_, row) => row?.ID">
                        <clr-dg-row [clrDgItem]="row">
                          @for (cell of messungenErl?.columns; track $index) {
                            <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
                          }
                        </clr-dg-row>
                      </ng-template>
                      <clr-dg-footer>{{ messungenErl?.rows?.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
                    </clr-datagrid>
                  </div>
                }
                @if (messungenErl?.rows.length) {
                  <div class="clr-col-12" style="padding-top: 10px">
                    <div class="btn-group btn-primary btn-icon">
                      <button
                        class="btn btn-icon btn btn-danger"
                        [title]="'Rückmeldung löschen' | mrTranslate"
                        [disabled]="trial || !selectedInstMessung"
                        (click)="onMessungDelRueckmeldung()">
                        <cds-icon shape="times" />
                      </button>
                    </div>
                  </div>
                }
              </div>
            </form>
          </clr-tab-content>
        </clr-tab>
      }

      @if ((typ_Line_Point | objtype) == 'point' && Opt_F_Drawing == 1 && isload == true) {
        <clr-tab class="w-100-p">
          <button clrTabLink (click)="tabChange('paint')" [title]="'Mangelskizzen' | mrTranslate">
            {{ 'Mangelskizzen' | mrTranslate }}
          </button>
          <clr-tab-content>
            <app-painting [setostammid]="ostammid" [setinittyp]="'3'" />
          </clr-tab-content>
        </clr-tab>
      }
    </clr-tabs>
  </div>
</div>

<clr-modal [(clrModalOpen)]="ismodteilinst" [clrModalClosable]="true" [clrModalSize]="modalsize">
  <h3 class="modal-title">{{ 'Teilinstandsetzung' | mrTranslate }}</h3>
  <div class="modal-body">
    <div class="clr-row">
      @if (typ_Line_Point == 2 || typ_Line_Point == 4) {
        <div class="clr-col-3">
          <div class="number-width">
            <clr-number-input-container>
              <label>{{ 'von' | mrTranslate }}</label>
              <input clrNumberInput type="number" #_modalvon />
            </clr-number-input-container>
          </div>
        </div>
        <div class="clr-col-3">
          <div class="number-width">
            <clr-number-input-container>
              <label>{{ 'bis' | mrTranslate }}</label>
              <input clrNumberInput type="number" #_modalbis />
            </clr-number-input-container>
          </div>
        </div>
        <div class="clr-col-3">
          <div class="number-width">
            <clr-number-input-container>
              <label>{{ 'Umfang' | mrTranslate }}</label>
              <input clrNumberInput type="number" #_modalumfang [disabled]="!caneditumfang" />
            </clr-number-input-container>
          </div>
        </div>
        <div class="clr-col-3">
          <div class="number-width">
            <clr-input-container>
              <label>{{ 'Mengeneinheit' | mrTranslate }}</label>
              <input clrInput #_modaleinheit [disabled]="true" />
            </clr-input-container>
          </div>
        </div>
      } @else {
        <div class="clr-col-6">
          <clr-number-input-container>
            <label>{{ 'Umfang' | mrTranslate }}</label>
            <input clrNumberInput type="number" #_modalumfang [disabled]="!caneditumfang" />
          </clr-number-input-container>
        </div>
        <div class="clr-col-6">
          <clr-input-container>
            <label>{{ 'Mengeneinheit' | mrTranslate }}</label>
            <input clrInput #_modaleinheit [disabled]="true" />
          </clr-input-container>
        </div>
      }
    </div>
    <br />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="createTeilinstandsetzung()">{{ 'OK' | mrTranslate }}</button>
    <button type="button" class="btn" (click)="ismodteilinst = false">{{ 'Abbrechen' | mrTranslate }}</button>
  </div>
</clr-modal>

<clr-modal [(clrModalOpen)]="ismoderneuerung" [clrModalClosable]="true" [clrModalSize]="'xl'">
  <h3 class="modal-title">{{ 'Erneuerung' | mrTranslate }}</h3>
  <div class="modal-body">
    <div class="clr-row" style="margin-top: -25px">
      <div class="clr-col-4">
        <clr-number-input-container>
          <label>{{ 'von' | mrTranslate }}</label>
          <input clrNumberInput type="number" #_neumodalvon />
        </clr-number-input-container>
      </div>
      <div class="clr-col-4">
        <clr-number-input-container>
          <label>{{ 'bis' | mrTranslate }}</label>
          <input clrNumberInput type="number" #_neumodalbis />
        </clr-number-input-container>
      </div>
      <div class="clr-col-4"></div>
    </div>

    <div class="clr-row">
      <div class="clr-col-5">
        <h4>{{ 'Spezifikation' | mrTranslate }}</h4>

        <form #spezFormPoint clrForm ngForm class="width100 margin-12-t" clrLabelSize="5">
          <table class="table margin-0-t table-compact nowrap">
            <thead style="position: sticky; top: 0; z-index: 3">
              <tr>
                <th class="left">{{ 'Objekt' | mrTranslate }}</th>
                <th class="left" style="width: 60%">{{ 'Bezeichnung' | mrTranslate }}</th>
                <th>{{ 'Pflicht' | mrTranslate }}</th>
              </tr>
            </thead>
            <tbody>
              @for (sp of spez; track sp) {
                <tr>
                  <td class="left">{{ sp.objekt | mrTranslate }}</td>
                  <td>
                    @switch (sp.fieldType) {
                      @case ('str') {
                        @if (sp.sField) {
                          <clr-select-container>
                            <select
                              class="clr-col-12"
                              clrSelect
                              [name]="sp.objekt"
                              [(ngModel)]="sp.bezeichnung"
                              [required]="!!sp.pflichtFeld"
                              [inTableValidator]="sp.wListe"
                              #sel
                              (change)="changed(sp.objekt, sel.value)">
                              <option [disabled]="sp.pflichtFeld" value=""></option>
                              @if (sp.bezeichnung && !sp.wListe.includes(sp.bezeichnung)) {
                                <option [value]="sp.bezeichnung" class="invalid-red">{{ sp.bezeichnung }}</option>
                              }
                              @for (wert of sp.wListe; track wert) {
                                <option [value]="wert">{{ wert }}</option>
                              }
                            </select>
                            <clr-control-error *clrIfError="'not-in-Table'; error as err">
                              {{ err | mrTranslate }}
                            </clr-control-error>
                            <clr-control-error *clrIfError="'required'">
                              {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                            </clr-control-error>
                          </clr-select-container>
                        } @else {
                          <!-- * FREI Texteingabefeld mit den bisherigen Werten -->
                          <clr-datalist-container>
                            <input
                              class="clr-col-12"
                              clrDatalistInput
                              [name]="sp.objekt"
                              [(ngModel)]="sp.bezeichnung"
                              [required]="!!sp.pflichtFeld" />
                            <clr-control-error *clrIfError="'required'">
                              {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                            </clr-control-error>
                          </clr-datalist-container>
                        }
                      }
                      <!-- Zahleneingabefeld number -->
                      @case ('dbl') {
                        <ng-container *ngTemplateOutlet="number; context: { float: true }"></ng-container>
                      }
                      @case ('int') {
                        <ng-container *ngTemplateOutlet="number; context: { float: false }"></ng-container>
                      }
                      <!-- Ja/Nein Einegabe -->
                      @case ('chk') {
                        <clr-toggle-container>
                          <clr-toggle-wrapper>
                            <input type="checkbox" clrToggle [name]="sp.objekt" [(ngModel)]="spez.bezeichnung" />
                          </clr-toggle-wrapper>
                        </clr-toggle-container>
                      }
                      <!-- Datum -->
                      @case ('dat') {
                        <clr-date-container>
                          <input
                            clrDate
                            [name]="sp.objekt"
                            autocomplete="off"
                            type="date"
                            [required]="!!sp.pflichtFeld"
                            [ngModel]="sp.bezeichnung | localeDate"
                            (ngModelChange)="sp.bezeichnung = localeDate.tosql($event)"
                            [ngModelOptions]="{ updateOn: 'blur' }" />
                          <clr-control-error *clrIfError="'required'">
                            {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                          </clr-control-error>
                        </clr-date-container>
                      }
                    }
                    <ng-template #number let-float="float">
                      <clr-number-input-container>
                        <input
                          class="clr-col-12"
                          clrNumberInput
                          [name]="sp.objekt"
                          [(ngModel)]="sp.bezeichnung"
                          type="number"
                          [step]="float ? 0.1 : 1"
                          [required]="!!sp.pflichtFeld" />
                        <clr-control-error *clrIfError="'required'">
                          {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
                        </clr-control-error>
                      </clr-number-input-container>
                    </ng-template>
                  </td>
                  <td>
                    @if (sp.pflichtFeld) {
                      <cds-icon shape="success-standard" solid="true" style="fill: #2ec0ff" />
                    }
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </form>
      </div>

      <div class="clr-col-7">
        <h4>{{ 'Herstelldaten' | mrTranslate }}</h4>
        <br />
        <form
          [formGroup]="herstellDatenForm"
          #f="ngForm"
          clrForm
          clrLayout="horizontal"
          class="width100 padding-24-r"
          clrLabelSize="6">
          <clr-select-container>
            <label>{{ 'Einbaufirma' | mrTranslate }}</label>
            <select clrSelect formControlName="Einbaufirma">
              @for (c of firmen; track c) {
                <option [value]="c.mFirma">{{ c.mFirma }}</option>
              }
            </select>
          </clr-select-container>
          <clr-date-container>
            <label>{{ 'Einbaudatum' | mrTranslate }}</label>
            <input
              clrDate
              name="Einbaudatum"
              autocomplete="off"
              type="date"
              [ngModel]="herstellDatenForm.controls['Einbaudatum'].value | localeDate"
              (ngModelChange)="herstellDatenForm.controls['Einbaudatum'].setValue(localeDate.tosql($event))"
              [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
              required />
            <clr-control-error *clrIfError="'required'">
              {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
            </clr-control-error>
          </clr-date-container>
          <clr-input-container>
            <label>{{ 'Erneuerungsjahr' | mrTranslate }}</label>
            <input
              clrInput
              formControlName="Erneuerungsjahr"
              name="Erneuerungsjahr"
              type="number"
              [step]="1"
              min="1800" />
            <clr-control-error *clrIfError="'required'">
              {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
            </clr-control-error>
            @if (herstellDatenForm.controls.Erneuerungsjahr.errors?.min; as err) {
              <clr-control-error>{{ 'Der Wert ist kleiner als' | mrTranslate }} {{ err.min }}</clr-control-error>
            }
          </clr-input-container>
          <clr-input-container>
            <label>{{ 'Nutzungsdauer' | mrTranslate }}</label>
            <input clrInput formControlName="Nutzungsdauer" name="Nutzungsdauer" type="number" [step]="1" min="1" />
            <clr-control-error *clrIfError="'required'">
              {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
            </clr-control-error>
            @if (herstellDatenForm.controls.Nutzungsdauer.errors?.min; as err) {
              <clr-control-error>{{ 'Der Wert ist kleiner als' | mrTranslate }} {{ err.min }}</clr-control-error>
            }
          </clr-input-container>
          <clr-input-container>
            <label>{{ 'Dauer der Gewährleistung' | mrTranslate }}</label>
            <input
              clrInput
              formControlName="DauerGewaehrleistung"
              name="DauerGewaehrleistung"
              type="number"
              [step]="1"
              min="0" />
            <clr-control-error *clrIfError="'required'">
              {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
            </clr-control-error>
            @if (herstellDatenForm.controls.DauerGewaehrleistung.errors?.min; as err) {
              <clr-control-error>{{ 'Der Wert ist kleiner als' | mrTranslate }} {{ err.min }}</clr-control-error>
            }
          </clr-input-container>
          <clr-select-container>
            <label>{{ 'Einheit der Gewährleistung' | mrTranslate }}</label>
            <select clrSelect formControlName="EinheitGewaehrleistung" name="EinheitGewaehrleistung">
              <option value="Tag">{{ 'Tag' | mrTranslate }}</option>
              <option value="Monat">{{ 'Monat' | mrTranslate }}</option>
              <option value="Jahr">{{ 'Jahr' | mrTranslate }}</option>
            </select>
          </clr-select-container>
          <clr-date-container>
            <label>{{ 'Ende der Gewährleistung' | mrTranslate }}</label>
            <input
              clrDate
              name="EndeGewaehrleistung"
              autocomplete="off"
              type="date"
              [ngModel]="herstellDatenForm.controls['EndeGewaehrleistung'].value | localeDate"
              (ngModelChange)="herstellDatenForm.controls['EndeGewaehrleistung'].setValue(localeDate.tosql($event))"
              [ngModelOptions]="{ updateOn: 'blur', standalone: true }"
              required />
            <clr-control-error *clrIfError="'required'">
              {{ 'Das Feld muss ausgefüllt werden' | mrTranslate }}
            </clr-control-error>
          </clr-date-container>
        </form>
      </div>
    </div>
    <br />
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="creatErneuerung()">{{ 'OK' | mrTranslate }}</button>
    <button type="button" class="btn" (click)="ismoderneuerung = false">{{ 'Abbrechen' | mrTranslate }}</button>
  </div>
</clr-modal>
